<template>
    <a-card>
        <span slot="title">
            Site: {{ site.name }}
            <a slot="extra">
                <router-link tag="a" :to="{ name: 'sites.index' }" class="pull-right">
                  <a-button type="primary"> <a-icon type="left" />
                   Back to Sites
                  </a-button>
                </router-link>
            </a>
        </span>

        <a-row :gutter="16">
            <a-col :span="8">
                <div class="card" style="height: 97%">
                    <div class="card-body" v-if="loading">
                        <VclList :height="350" :width="380"></VclList>
                    </div>
                    <div class="card-body" v-else>
                      <div class="h5">Name: {{ site.name }}</div>
                      <div class="h5">URL: <a :href="site.site_url" target="_blank">{{ site.site_url }}</a></div>
                      <div class="h5">Created: {{ site.created_at }}</div>
                      <a-badge v-if="site.deactivated_at" :count="'Disconnected at: ' + site.deactivated_at" :number-style="{ backgroundColor: '#e9452c' }" />
                      <a-badge v-else count="Connected with weMail" :number-style="{ backgroundColor: '#52c41a' }" />
                    </div>
                </div>
            </a-col>
            <a-col :span="8"></a-col>
            <a-col :span="8">
                <div class="card" style="height: 97%">
                    <div class="card-body" v-if="loading">
                        <VclList :height="350" :width="380"></VclList>
                    </div>
                    <div class="card-body" v-else>
                      <template v-if="site.email_gateway">
                        <div class="h5">Mail Driver: {{ site.email_gateway.name }}</div>
                        <div class="h5">Limit: {{ site.email_gateway.limit }}</div>
                      </template>
                      <template v-else>
                        <a-badge class="pull-right" count="Running on test mode" :number-style="{ backgroundColor: '#e3820e' }" />
                      </template>
                    </div>
                </div>
            </a-col>
        </a-row>
    </a-card>
</template>

<script>
  import Api from "@/services/Api.js";
  import { VclList } from 'vue-content-loading';

  export default {
    components: {VclList},
    data() {
      return {
        site: {},
        loading: false
      };
    },

    methods: {
        loadSiteOverviewData() {
          this.loading = true;
          Api.get(`/sites/${this.$route.params.siteId}/overview/details`).then(res => {
              this.site = res.data;
              this.loading = false;
            }).catch(err => {
            this.loading = false;
          })
        }
    },
    created() {
        this.loadSiteOverviewData();
    },

    watch: {
        '$route.params.id': function (newVal, oldVal) {
          if (oldVal !== newVal) {
            this.loadSiteOverviewData();
          }
        }
    }
  };
</script>

<style>

</style>